angular.module('services.newman.PublishService', [
  'global'
])

/**
 * The PublishService service stores methods used to access
 * system APIs.
 *
 * @class PublishService
 * @constructor
 * @module services.newman.PublishService
 */
.factory('PublishService', [
  '$rootScope',
  '$http',
  'ModelsService',
  function ($rootScope, $http, ModelsService) {
    'use strict';

    var service = {

      queue: [],

      publications: [],

      builds: {},


      getBuilds: function getBuilds() {
        // load dev build version file
        $http
          .get(
            $rootScope.config.ENVIRONMENTS.development.replace('newman/api/', 'build-version.json')
          )
          .then(function (response) {
            service.builds.development = response.data;
            return;
          })
          .catch(function () {
            service.builds.development = { content: 'NOT FOUND', app: 'NOT FOUND' };
          });

        // load staging build version file
        $http
          .get($rootScope.config.ENVIRONMENTS.staging.replace('newman/api/', 'build-version.json'))
          .then(function (response) {
            service.builds.staging = response.data;
            return;
          })
          .catch(function () {
            service.builds.staging = { content: 'NOT FOUND', app: 'NOT FOUND' };
          });

        // load production build version file
        $http
          .get(
            $rootScope.config.ENVIRONMENTS.production.replace('newman/api/', 'build-version.json')
          )
          .then(function (response) {
            service.builds.production = response.data;
            return;
          })
          .catch(function () {
            service.builds.production = { content: 'NOT FOUND', app: 'NOT FOUND' };
          });
      },

      /**
       * Returns publications.  If an id is
       * provided will return a single publication.
       * If no id is provided will return all publications.
       *
       * @param {string} [id] - return only a specific publication
       * @return {Object|Array<Object>} All entries
       */
      get: function get(id) {
        var ret;

        service.publications = ModelsService.read('publications');

        if (id) {
          ret = _.find(service.publications, { id: id });
        } else {
          ret = service.publications;
        }

        return ret;
      },

      /**
       * Creates a new publications entry
       *
       * @param {string} caseId - Publication data
       * @param {Object} source - source
       * @param {Object} destination - destination
       * @return {Promise<Object>} New publication
       */
      create: function create(caseId, source, destination) {
        var data = {
          label: 'publication-' + uuid.v1(),
          content: {
            caseId: caseId,
            source: source,
            destination: destination,
            started: null,
            completed: null,
            user: $rootScope.user
          }
        };

        var promise = ModelsService
          .create(ModelsService.find('endpoints', 'label', 'publications'), data);

        return promise;
      }

    };

    return service;
  }
]);
